import React, { useContext, useEffect, useState, useRef, useMemo } from 'react'
import * as Yup from 'yup'
import './Draft.css'
import 'react-tagsinput/react-tagsinput.css'
import dayjs from 'dayjs'
import { setIn, useFormik } from 'formik'
import {
    Button,
    Dialog,
    Checkbox,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Tooltip,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
} from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { mapData } from '@/product/common/components'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
import TagsInput from 'react-tagsinput'
import CustomDialog from '@/product/components/organisms/Dialog'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import CustomInput from '@/product/components/atoms/Inputs/CustomInput'
import CustomTextArea from '@/product/components/atoms/Inputs/CustomTextArea'
import CustomSelect from '@/product/components/atoms/Inputs/CustomSelect'
// import CustomTagsInput from '@/product/components/atoms/Inputs/CustomTagsInput'
import AuthContext from '@/product/context/auth/authContext'
import ProductContext from '@/product/context/product/productContext'
import ProductCustomState from '@/custom/context/product/productContext'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import AlertContext from '@/product/context/alert/alertContext'
// import ProductCommonContext from '@/product/context/common/commonContext'
import { editValue } from '@/product/components/species/dynamic/common/FieldFunction'
import CustomCommonContext from '@/custom/context/common/commonContext'
import Loaders from '@/product/components/molecules/Loaders'
import {
    dateTimeFormatFunction,
    isValidHttpUrl,
} from '../../../custom/common/components'
import NoRecordsFound from '@/product/components/atoms/NoRecordsFound'
import ImageZoom from '@/custom/components/organisms/ImageZoom'
import {
    DndContext,
    closestCenter,
    PointerSensor,
    useSensor,
    useSensors,
} from '@dnd-kit/core'
import {
    SortableContext,
    useSortable,
    arrayMove,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import zIndex from '@mui/material/styles/zIndex'

const EditModal = (props) => {
    const from = `newDraftListing`
    const divRefs = useRef({})
    const [isLoading, setIsLoading] = useState(true)
    const [commentsLoading, setCommentsLoading] = useState(false)
    const [submitPopup, setSubmitPopup] = useState(false)
    const [showMore, setShowMore] = useState(false)
    const [product, setProduct] = useState({ uploadImages: [] })
    const [productComments, setProductComments] = useState([])
    const [initialValues, setInitialValues] = useState({})
    const [fileUploaded, setFileUploaded] = useState('')
    const [addPhotos, setAddPhotos] = useState(false)
    const [imageZoomModal, setImageZoomModal] = useState(false)
    const [inputFocus, setInputFocus] = useState(false)
    const [imageIndex, setImageIndex] = useState(0)
    const [imagesOrder, setImagesOrder] = useState([])
    const productContext = useContext(ProductContext)
    const productCustomState = useContext(ProductCustomState)
    const authContext = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const { user, isAdmin } = authContext
    const { alldata_all_dropdown, allLocations, allCategory, allCondition } =
        useContext(CustomCommonContext)
    // const { allCountries, allStates, allCities } =
    //     useContext(ProductCommonContext)
    const dynamicContext = useContext(DynamicContext)
    const { project_dynamicfields } = dynamicContext
    const { projectAction, responseStatus: responseStatusProduct } =
        productContext
    const { project_comments, getProjectComments } = productCustomState

    const fileValidationArray = Yup.object({
        file_path: Yup.array().when('content_type', {
            is: 'file',
            then: Yup.array().required('Required!'),
        }),
    })
    const fileFormik = useFormik({
        initialValues: {
            file_path: [],
        },
        // validationSchema: fileValidationArray,
        onSubmit: (values) => {},
    })

    const handleUpload = (newData) => {
        setFileUploaded(newData)
    }

    useEffect(() => {
        if (fileUploaded?.name) {
            setInputFocus(true)
            formik.setFieldValue('updateLotImages', true)
            // const currentImages = Array.isArray(product.uploadimages)
            //     ? product.uploadimages
            //     : []
            // formik.setFieldValue('uploadimages', [
            //     ...currentImages,
            //     fileUploaded,
            // ])
        }
    }, [fileUploaded])

    const fileUpload = {
        formik: fileFormik,
        data: [
            {
                type: 'uploadDropZone',
                name: 'file_path',
                icon: 'description',
                titleText: 'Upload Lot Images',
                class: `col-12`,
                folder: 'product',
                multiple: true,
                disableEditing: true,
                getBlobUrl: handleUpload,
                webcam: false,
                accept: 'image/*',
                reorder: true,
                // showFileName: true,
            },
        ],
    }

    const getComments = () => {
        setCommentsLoading(true)
        getProjectComments({ project_id: props.productDetails.id })
    }

    useEffect(() => {
        setProductComments(
            project_comments?.records?.length > 0
                ? project_comments?.records
                : []
        )
        setCommentsLoading(false)
    }, [project_comments])

    // console.log(project_comments, 'project_comments11')

    useEffect(() => {
        if (props.open) {
            let projectDynamicArray = [...project_dynamicfields]
            projectDynamicArray = projectDynamicArray.filter(
                (data) => data.active === 1
            )

            projectDynamicArray.push(
                {
                    name: 'avatar',
                    value: props?.productDetails?.avatar,
                    type: 'text',
                    active: 1,
                },
                {
                    name: 'end_date',
                    value: props?.productDetails?.end_date,
                    type: '',
                    active: 1,
                },
                {
                    name: 'end_time',
                    value: props?.productDetails?.end_time,
                    type: '',
                    active: 1,
                },
                {
                    name: 'comment',
                    value: '',
                    type: 'text',
                    active: 1,
                },
                {
                    name: 'duplicate_count',
                    value: props?.productDetails?.duplicate_count,
                    type: 'number',
                    active: 1,
                },
                {
                    name: 'created_at',
                    value: props?.productDetails?.created_at,
                    type: 'datetime',
                    active: 1,
                },
                {
                    name: 'keywords',
                    value: props?.productDetails?.keywords,
                    type: 'text',
                    active: 1,
                },
                {
                    name: 'sub_category',
                    value: props?.productDetails?.sub_category,
                    type: 'number',
                    active: 1,
                }
            )

            let objectPush = editValue(
                projectDynamicArray,
                props.productDetails
            )
            setProduct(props.productDetails)

            setInitialValues({
                ...objectPush,
                bprice: props?.productDetails?.bprice || null,
                duplicateLotCount: 1,
                keywords: objectPush.keywords?.length
                    ? String(objectPush.keywords).split(',')
                    : [],
                // item_tags: String(objectPush.item_tags).split(','),
            })
            setTimeout(() => {
                setIsLoading(false)
            }, 500)
        } else {
            setProduct({})
        }
        return () => {
            setAddPhotos(false)
            setInputFocus(false)
            setProduct({})
            setShowMore(false)
            fileFormik.resetForm()
        }
    }, [props.open])

    useEffect(() => {
        if (responseStatusProduct) {
            if (responseStatusProduct.status === 'success') {
                if (
                    responseStatusProduct?.from === 'draftListingPopup' ||
                    responseStatusProduct?.from === from
                ) {
                    props.handleClose()
                }
            }
        }
        setIsLoading(false)
    }, [responseStatusProduct])

    const validationArray = Yup.object({
        title: Yup.string().required('Title is a required field'),
        item_id: Yup.string().required('Please enter a valid Item ID'),
        desc_proc: Yup.string().required('Please enter a valid Description'),
        end_date: Yup.date()
            .required('Please select a valid End Date')
            .typeError('Please select a valid End Date'),
        end_time: Yup.string()
            .required('Please select a valid End Time')
            .typeError('Please select a valid End Time'),
        warehouse_name: Yup.string().required(
            'Please enter a valid Warehouse/Facility Name'
        ),
        bin_location: Yup.string().required(
            'Please enter a valid location in facility'
        ),
        category: Yup.string().required('Please select a valid Category'),
        qty: Yup.number().required('Please select a quantity'),
        // sub_category: Yup.string().required(
        //     'Please select a valid Sub Category'
        // ),
        // truck_code: Yup.string().required('Please enter a valid Truck code'),
        // asin_price: Yup.number().required('Please enter a valid Retail Price'),
    })

    const formik = useFormik({
        initialValues: initialValues,
        validateOnBlur: true,
        enableReinitialize: true,
        validationSchema: validationArray,
        onSubmit: (values) => {
            // formSubmitFunction(values)
        },
    })

    const throwAlert = (message) =>
        setAlert(message || 'Please enter all required fields', 'error')

    const qtyOptions = useMemo(
        () =>
            Array.from({ length: 100 }, (_, index) => ({
                show: index + 1,
                value: index + 1,
            })),
        []
    )

    const statusOptions = [
        { show: 'Live', value: 'live' },
        { show: 'Fix', value: 'fix' },
        { show: 'Ready', value: 'ready' },
        { show: 'Pending', value: 'pending' },
        { show: 'Delete', value: 'delete' },
    ]

    const category_options = useMemo(() => {
        return allCategory
            ?.filter((category) => category.level === 0 && category.active)
            .map(({ description, id }) => ({
                show: description,
                value: id,
            }))
    }, [allCategory])

    // const category_options = allCategory
    //     ?.filter((category) => category.level === 0 && category.active)
    //     .map(({ description, id }) => ({
    //         show: description,
    //         value: id,
    //     }))

    const sub_category_options = useMemo(
        () =>
            allCategory?.reduce(
                (acc, { level, active, level_id, id, description }) => {
                    if (level === 1 && active) {
                        acc[level_id] = acc[level_id] || []
                        acc[level_id].push({ val: id, show: description })
                    }
                    return acc
                },
                {}
            ),
        [allCategory]
    )

    // const condition_types = allCondition
    //     ?.filter((condition) => condition.active)
    //     .map((conditionObj) => ({
    //         show: conditionObj.description,
    //         value: conditionObj.id,
    //     }))

    // const result = alldata_all_dropdown?.reduce(
    //     (acc, item) => {
    //         if (item.active === 1) {
    //             const { variable, id, description } = item
    //             const formattedItem = { value: id, show: description }

    //             if (variable === 'category') {
    //                 acc.categoryOptions.push(formattedItem)
    //             } else if (variable === 'conditionTypeId') {
    //                 acc.conditionTypes.push(formattedItem)
    //             }
    //         }
    //         return acc
    //     },
    //     { categoryOptions: [], conditionTypes: [] }
    // )
    // const { categoryOptions, conditionTypes } = result

    const { categoryOptions, conditionTypes } = useMemo(() => {
        return (
            alldata_all_dropdown?.reduce(
                (acc, item) => {
                    if (item.active === 1) {
                        const { variable, id, description } = item
                        const formattedItem = { value: id, show: description }

                        if (variable === 'category') {
                            acc.categoryOptions.push(formattedItem)
                        } else if (variable === 'conditionTypeId') {
                            acc.conditionTypes.push(formattedItem)
                        }
                    }
                    return acc
                },
                { categoryOptions: [], conditionTypes: [] }
            ) || { categoryOptions: [], conditionTypes: [] }
        )
    }, [alldata_all_dropdown])

    const handleTagsChange = (tags) => formik.setFieldValue(`keywords`, tags)

    const getDateClosed = () => {
        // const { end_date, end_time } = formik.values
        // const endDate = dayjs(end_date, 'YYYY-MM-DD')
        // const endTime = dayjs(end_time, 'hh:mm:ss a').format('HH:mm:ss')

        const endDate = dayjs(formik.values.end_date).format('YYYY-MM-DD')
        const endTime = dayjs(formik.values.end_time, 'hh:mm:ss a').format(
            'HH:mm:ss'
        )

        let date_closed = dayjs(`${endDate}T${endTime}`).format(
            'YYYY-MM-DDTHH:mm:ssZ'
        )
        console.log(`endDate and endDate final `, endDate, endTime, date_closed)
        date_closed = dayjs(date_closed).isValid() ? date_closed : null
        formik.setFieldValue('date_closed', date_closed)
        return date_closed
    }

    const onClickPreview = (e, id) => {
        e.preventDefault()
        window.open(
            `${process.env.REACT_APP_FRONTEND_URL}productView/${id}`,
            // `http://localhost:3000/productView/${id}`,
            '_blank',
            'noopener,noreferrer'
        )
    }

    const setFormikField = (e, field, type) => {
        if (type === 'text') {
            formik.setFieldValue(field, e.target.value)
        }
    }

    const validateForm = async () => {
        const errors = await formik.validateForm()
        if (Object.keys(errors).length > 0) {
            throwAlert(Object.values(errors)[0])
            return false
        }
        return true
    }

    const duplicateLot = async (e) => {
        e.preventDefault()
        setIsLoading(true)
        const isValid = await validateForm()
        if (!isValid) {
            setIsLoading(false)
            return
        }

        const date_closed = getDateClosed()
        console.log(`formik.values duplicateLot `, formik.values)
        projectAction(
            {
                ...formik.values,
                // id: 0,
                // status: 'live',
                category: formik.values.category
                    ? formik.values.category
                    : null,
                sub_category: formik.values.sub_category
                    ? formik.values.sub_category
                    : null,
                date_closed: date_closed,
                keywords: Array.from(formik.values.keywords).toString(),
                // item_tags: Array.from(formik.values.item_tags).toString(),
            },
            from,
            true
        )
    }

    const projectUpdate = async (e, direction) => {
        e.preventDefault()
        const date_closed = getDateClosed()
        console.log(`formik before validation`, formik.values, date_closed)

        if (!dayjs(date_closed).isValid()) {
            throwAlert('Please select valid End Date and Time')
            return
        }

        // Added future date validation
        const now = dayjs()
        const selectedDateTime = dayjs(date_closed)

        if (selectedDateTime.isBefore(now)) {
            throwAlert('End Date and Time must be in the future')
            return
        }

        const uploadImages = [
            imagesOrder.toString(),
            fileFormik.values.file_path?.toString(),
        ]
            .filter(Boolean)
            .map((imageUrl) => imageUrl.trim())
            .join(',')

        if (
            formik.values.status === 'live' ||
            formik.values.status === 'ready'
        ) {
            const isValid = await validateForm()
            if (!isValid || uploadImages.length < 1) {
                setIsLoading(false)
                if (!isValid) {
                    return
                }
                throwAlert('Upload at least one lot image')
                return
            }
        }

        if (
            (product.status === 'fix' || product.status === 'pending') &&
            formik.values.status === 'live'
        ) {
            setIsLoading(false)
            throwAlert('Cannot move Item to Live until Approved')
            return
        }

        setIsLoading(true)

        console.log(`formik after validateForm `, formik.values)
        const payload = {
            ...formik.values,
            category: formik.values.category ? formik.values.category : null,
            sub_category: formik.values.sub_category
                ? formik.values.sub_category
                : null,
            date_closed: date_closed,
            is_approved:
                formik.values.status === 'ready' ||
                formik.values.status === 'live'
                    ? 1
                    : 0,
            market_status: formik.values.status === 'live' ? 'open' : 'draft',
            direction: direction,
            fetch_project_id:
                direction === 'next' ? props.next_id : props.prev_id,
            duplicateLotCount: 0,
            uploadimages: uploadImages,
            buynow: Number(formik.values.bprice) > 0 ? 1 : 0,
            keywords: Array.from(formik.values.keywords).toString(),
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            updateLotImages: true,
        }
        payload.location_id = payload.location
        payload.warehouse_id = payload.location
        console.log(`payload projectAction `, payload)
        projectAction(payload, `draftListingPopup`, true)
    }

    const copyExternalURL = (e, field) => {
        if (formik.values[field]) {
            navigator.clipboard
                .writeText(formik.values[field])
                .then(() => {
                    setAlert('Link copied to clipboard!', 'info')
                })
                .catch((err) => {
                    console.error('Failed to copy: ', err)
                })
        } else {
            setAlert('No content to copy', 'error')
        }
    }

    const [openComments, setOpenComments] = useState(false)
    const [newComment, setNewComment] = useState('')

    const handleOpenComments = () => setOpenComments(true)
    const handleCloseComments = () => setOpenComments(false)

    const handleAddComment = () => {
        if (newComment.trim()) {
            // setProductComments((prevComments) => [...prevComments, newComment]);
            // setNewComment("");
        }
        setOpenComments(false)
    }

    const validateAndClose = () => {
        // if (Object.keys(formik.touched).length > 0 && !formik.isSubmitting) {
        if (inputFocus) {
            setSubmitPopup(true)
        } else {
            props.handleClose()
        }
    }

    // This is for text fields to take size equal to of the text height
    const handleInput = (id) => {
        const div = divRefs.current[id]
        div.style.height = 'auto'
        div.style.height = `${div.scrollHeight}px`
    }

    const handleChange = (e, id) => {
        formik.setFieldValue(id, e.target.innerText)
    }

    useEffect(() => {
        Object.keys(divRefs.current).forEach((id) => {
            const div = divRefs.current[id]
            if (div) {
                div.style.height = 'auto'
                div.style.height = `${div.scrollHeight}px`
            }
        })
    }, [props])

    //Image zoom component

    const handleImageClick = (index) => {
        setImageIndex(index)
        setImageZoomModal(true)
    }

    const toggleImage = (direction) => {
        if (
            direction === 'next' &&
            imageIndex < product.uploadimages.length - 1
        ) {
            setImageIndex(imageIndex + 1)
        } else if (direction === 'prev' && imageIndex > 0) {
            setImageIndex(imageIndex - 1)
        }
    }

    const images = useMemo(() => {
        return product?.uploadimages
            ? product.uploadimages.split(',').map((image) => ({
                  main: isValidHttpUrl(image)
                      ? image
                      : `${global.images_url}${image}`,
              }))
            : []
    }, [product])

    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                delay: 100,
                tolerance: 5,
            },
        })
    )

    useEffect(() => {
        if (product?.avatar || product?.uploadimages) {
            const avatar = product?.avatar ?? null
            const uploadImages = product?.uploadimages
                ? String(product.uploadimages).split(',').filter(Boolean)
                : []

            const allImages = uploadImages
            // const allImages = [...(avatar ? [avatar] : []), ...uploadImages]
            setImagesOrder(allImages)
        }
    }, [product?.avatar, product?.uploadimages])

    // Handle drag end event to reorder images
    const onDragEnd = (event) => {
        const { active, over } = event

        if (over && active.id !== over.id) {
            const from = imagesOrder.findIndex((file) => file === active.id)
            const to = imagesOrder.findIndex((file) => file === over.id)

            if (from !== -1 && to !== -1) {
                const reorderedItems = arrayMove(imagesOrder, from, to)
                setImagesOrder(reorderedItems)
                setInputFocus(true)
                formik.setFieldValue('updateLotImages', true)
            }
        }
    }

    // Update `SortableImage` component for dynamic styling
    const SortableImage = ({ id, file, index, className, removeImage }) => {
        const {
            attributes,
            listeners,
            setNodeRef,
            transform,
            transition,
            isDragging,
        } = useSortable({ id })

        const style = {
            transform: CSS.Transform.toString(transform),
            transition,
            opacity: isDragging ? 0.5 : 1,
            cursor: 'grab',
            zIndex: isDragging ? 1000 : 1,
            position: 'relative', // Ensure relative positioning for the image container
        }

        return (
            <div
                ref={setNodeRef}
                style={style}
                // {...attributes}
                // {...listeners}
                className={`thumb ${className}`}
            >
                <div className="thumbInner">
                    <div className="thumbCnt">
                        <img
                            src={
                                isValidHttpUrl(file)
                                    ? file
                                    : `${global.images_url}${file}`
                            }
                            className="img"
                            id={`thumb_${index}`}
                            alt="File Thumbnail"
                            onClick={() => handleImageClick(index)}
                        />
                        {isDragging ? (
                            <div className="dragIcon">
                                <span className="material-icons">
                                    open_with
                                </span>
                            </div>
                        ) : (
                            <Tooltip title="Delete" placement="top">
                                <span
                                    className="material-icons closeBtn"
                                    onClick={(e) => removeImage(index, e)}
                                >
                                    delete
                                </span>
                            </Tooltip>
                        )}
                    </div>
                </div>
            </div>
        )
    }

    const removeImage = (removeIndex) => {
        setImagesOrder((prevImageList) =>
            prevImageList.filter((_, index) => index !== removeIndex)
        )
    }

    return (
        <>
            <Dialog
                open={props.open}
                onClose={() => {
                    validateAndClose()
                }}
                className="returnflowDialog proEditView"
            >
                {isLoading ? (
                    <Loaders name={`product_view`} isLoading={isLoading} />
                ) : (
                    <>
                        <div className="d-flex justify-content-end">
                            <Button
                                className="material-symbols-outlined modalClosePerment editCancelModel"
                                onClick={() => {
                                    validateAndClose()
                                }}
                            >
                                <span className="material-icons">cancel</span>
                            </Button>
                        </div>
                        <DialogContent className="pb-2">
                            <div className="editTitleCnt">
                                <label className="titleLabel">Title :</label>
                                <CustomTextArea
                                    type="text"
                                    name={`title`}
                                    isDefault={true}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    placeholder="Enter Title"
                                    value={formik.values.title}
                                    onFocus={() => setInputFocus(true)}
                                />
                            </div>
                            <div className="formFields">
                                <label>All photos :</label>
                                <div className="imgCollageBox">
                                    {/* Drag-and-drop context for all images */}
                                    {/* <img
                                        src={
                                            isValidHttpUrl(product.avatar)
                                                ? product.avatar
                                                : `${global.images_url}${product.avatar}`
                                        }
                                        alt={product.title}
                                        onError={(e) =>
                                            (e.target.src =
                                                '/assets/images/noimage.png')
                                        }
                                        className="large"
                                        onClick={() => handleImageClick(0)}
                                    /> */}
                                    <DndContext
                                        sensors={sensors}
                                        collisionDetection={closestCenter}
                                        onDragEnd={onDragEnd}
                                    >
                                        <SortableContext
                                            items={imagesOrder}
                                            strategy={
                                                verticalListSortingStrategy
                                            }
                                        >
                                            {/* Main large image */}
                                            {imagesOrder.length > 0 && (
                                                <div className="largeImageWrapper">
                                                    <SortableImage
                                                        key={imagesOrder[0]}
                                                        id={imagesOrder[0]}
                                                        file={imagesOrder[0]}
                                                        index={0}
                                                        className="large"
                                                        removeImage={
                                                            removeImage
                                                        }
                                                    />
                                                </div>
                                            )}

                                            {/* Drag-and-drop images in img little finger box */}
                                            <div className="imglittlefingerBox">
                                                {imagesOrder.length > 0 ? (
                                                    imagesOrder
                                                        .slice(1)
                                                        .map((file, index) => (
                                                            <SortableImage
                                                                key={file}
                                                                id={file}
                                                                file={file}
                                                                index={
                                                                    index + 1
                                                                }
                                                                removeImage={
                                                                    removeImage
                                                                }
                                                            />
                                                        ))
                                                ) : (
                                                    <img
                                                        src="/assets/images/noimage.png"
                                                        className="small"
                                                        alt="thumbnail"
                                                    />
                                                )}
                                            </div>
                                        </SortableContext>
                                    </DndContext>

                                    {/* Image Zoom component */}
                                    <ImageZoom
                                        imageZoomModal={imageZoomModal}
                                        toggleImage={toggleImage}
                                        images={images}
                                        imageIndex={imageIndex}
                                        setImageZoomModal={setImageZoomModal}
                                    />
                                </div>
                            </div>
                            <div className="formfields dropZoneField">
                                <Button
                                    className="primaryButton uploadPhotoBtn"
                                    onClick={(e) => setAddPhotos(!addPhotos)}
                                >
                                    {addPhotos ? 'Hide' : 'Add Photos'}
                                </Button>
                                <>
                                    {addPhotos ? (
                                        <div className="row fileUploadRow">
                                            {mapData(fileUpload)}
                                        </div>
                                    ) : null}
                                </>
                            </div>

                            <div className="formFields mt-2">
                                <label>Product link :</label>
                                <CustomInput
                                    type="text"
                                    name={`external_url`}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    placeholder="Enter Product Link"
                                    value={formik.values.external_url}
                                    onFocus={() => setInputFocus(true)}
                                    endAdornment={
                                        <span
                                            className="material-icons-outlined"
                                            style={{ cursor: 'pointer' }}
                                            onClick={(e) => {
                                                copyExternalURL(
                                                    e,
                                                    `external_url`
                                                )
                                            }}
                                        >
                                            link
                                        </span>
                                    }
                                />
                            </div>
                            <div className="formFields mt-2">
                                <label>Disclaimer</label>
                                <CustomInput
                                    type="text"
                                    name={`disclaimer`}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    placeholder="Enter Disclaimer"
                                    value={formik.values.disclaimer}
                                    onFocus={() => setInputFocus(true)}
                                />
                            </div>
                            {/* <div className="formFields"> */}
                            <div className="">
                                <label>Description :</label>
                                <CustomTextArea
                                    multiline
                                    isDefault={true}
                                    name={`desc_proc`}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.desc_proc}
                                    onFocus={() => setInputFocus(true)}
                                />
                            </div>
                            <div className="formFields">
                                <label>Item ID :</label>
                                <CustomInput
                                    type="text"
                                    name={`item_id`}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleChange}
                                    value={formik.values.item_id}
                                    onFocus={() => setInputFocus(true)}
                                    placeholder="Enter Item ID"
                                />
                            </div>
                            {/* <div className="formFields">
                                <label>Notes :</label>
                                <CustomInput
                                    // label={`Item ID`}
                                    type="text"
                                    name={`notes`}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.notes}
                                    placeholder="Enter Notes"
                                />
                            </div> */}
                            <div className="formFields">
                                <label>Comments :</label>
                                <CustomInput
                                    className="textAreaField"
                                    name={`comment`}
                                    value={formik.values.comment}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    placeholder="Enter Comment"
                                />
                                <div className="text-center">
                                    <Button
                                        className="primaryButton mb-4"
                                        onClick={(e) => {
                                            setOpenComments(true)
                                            getComments()
                                        }}
                                    >
                                        View History
                                    </Button>
                                </div>
                                <Dialog
                                    open={openComments}
                                    onClose={handleCloseComments}
                                    className="commentsDialog"
                                >
                                    <DialogTitle>
                                        Comments
                                        <span
                                            className="material-icons"
                                            onClick={() =>
                                                setOpenComments(false)
                                            }
                                        >
                                            cancel
                                        </span>
                                    </DialogTitle>
                                    <DialogContent>
                                        {commentsLoading ? (
                                            <Loaders
                                                name={``}
                                                isLoading={commentsLoading}
                                            />
                                        ) : (
                                            <>
                                                {productComments?.length ? (
                                                    productComments?.map(
                                                        (comment) => (
                                                            <>
                                                                <div>
                                                                    <p className="notes">
                                                                        {
                                                                            comment.notes
                                                                        }{' '}
                                                                        <br />
                                                                        <span className="updates">
                                                                            {dateTimeFormatFunction(
                                                                                comment.created_at
                                                                            )}{' '}
                                                                            by{' '}
                                                                            {`${comment.emp_firstname} ${comment.emp_lastname}`}
                                                                        </span>
                                                                    </p>
                                                                </div>
                                                            </>
                                                        )
                                                    )
                                                ) : (
                                                    <div className="text-center">
                                                        <NoRecordsFound />
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </DialogContent>
                                </Dialog>
                            </div>
                            <div className="gridBoxSwap verticalView">
                                <div className="tableCerseInput priceCls">
                                    <label>Retail price :</label>
                                    <CustomInput
                                        type="number"
                                        name={`asin_price`}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.asin_price}
                                        onFocus={() => setInputFocus(true)}
                                        placeholder="Enter Retail Price"
                                        startAdornment={
                                            <span className="material-icons-outlined">
                                                attach_money
                                            </span>
                                        }
                                    />
                                </div>
                                <div className="tableCerseInput priceCls">
                                    <label>Buy now price :</label>
                                    <CustomInput
                                        label={``}
                                        type="number"
                                        name={`bprice`}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        placeholder="Enter Buy Now Price"
                                        onFocus={() => setInputFocus(true)}
                                        value={
                                            formik.values.bprice > 0
                                                ? formik.values.bprice
                                                : ''
                                        }
                                        startAdornment={
                                            <span className="material-icons-outlined">
                                                attach_money
                                            </span>
                                        }
                                    />
                                </div>
                            </div>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <div className="gridBoxSwap verticalView timerCls">
                                    <div className="tableCerseInput">
                                        <label>End Date :</label>
                                        <DatePicker
                                            disablePast
                                            value={dayjs(
                                                formik.values.end_date
                                            )}
                                            onChange={(newDate) => {
                                                setInputFocus(true)
                                                formik.setFieldValue(
                                                    `end_date`,
                                                    newDate
                                                )
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Select End Date"
                                                    InputProps={{
                                                        endAdornment: (
                                                            <span className="material-icons-outlined">
                                                                calendar_month
                                                            </span>
                                                        ),
                                                    }}
                                                />
                                            )}
                                        />
                                    </div>
                                    <div className="tableCerseInput timerCls">
                                        <label>End Time :</label>
                                        <TimePicker
                                            value={dayjs(
                                                formik.values.end_time,
                                                'HH:mm:ss a'
                                            )}
                                            onChange={(newTime) => {
                                                setInputFocus(true)
                                                formik.setFieldValue(
                                                    `end_time`,
                                                    newTime
                                                )
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Select End Time"
                                                    InputProps={{
                                                        endAdornment: (
                                                            <span className="material-icons-outlined">
                                                                schedule
                                                            </span>
                                                        ),
                                                    }}
                                                />
                                            )}
                                        />
                                    </div>
                                </div>
                            </LocalizationProvider>

                            <div className="actionBtnGrops mt-4">
                                <Button
                                    onClick={(e) =>
                                        onClickPreview(e, product.id)
                                    }
                                    className="secondaryButton"
                                >
                                    Preview Listing
                                </Button>
                                {/* <CustomSelect
                                    value={formik.values.status}
                                    onChange={(e) => {
                                        setInputFocus(true)
                                        formik.setFieldValue(
                                            `status`,
                                            e.target.value
                                        )
                                    }}
                                    options={statusOptions}
                                    className="secondaryselectField"
                                /> */}
                                <div
                                    className={`customSelect nonNative secondaryselectField`}
                                >
                                    <FormControl fullWidth>
                                        <Select
                                            id="status"
                                            labelId="status-label"
                                            value={
                                                formik.values.status || 'live'
                                            }
                                            onChange={(e) => {
                                                setInputFocus(true)
                                                formik.setFieldValue(
                                                    `status`,
                                                    e.target.value
                                                )
                                            }}
                                            renderValue={(selected) => {
                                                if (!selected) {
                                                    return 'Select a Status'
                                                }
                                                const selectedOption =
                                                    statusOptions?.find(
                                                        (opt) =>
                                                            opt.value ===
                                                            selected
                                                    )
                                                return selectedOption
                                                    ? selectedOption.show
                                                    : 'Select a Status'
                                            }}
                                            name="status"
                                        >
                                            {statusOptions?.map((opt) => (
                                                <MenuItem
                                                    key={opt.value}
                                                    value={opt.value}
                                                >
                                                    {opt.show}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="btnGridSwap">
                                    <Button
                                        className="primaryButton"
                                        disabled={!props.prev_id}
                                        onClick={(e) =>
                                            projectUpdate(e, `prev`)
                                        }
                                    >
                                        Save + Prev
                                    </Button>
                                    <Button
                                        className="primaryButton"
                                        onClick={(e) => projectUpdate(e)}
                                    >
                                        Save
                                    </Button>
                                    <Button
                                        className="primaryButton"
                                        disabled={!props.next_id}
                                        onClick={(e) =>
                                            projectUpdate(e, `next`)
                                        }
                                    >
                                        Save + Next
                                    </Button>
                                </div>
                                <small className="d-block my-2 text-center">
                                    Last Updated:{' '}
                                    {dateTimeFormatFunction(product.updated_at)}
                                </small>
                                <small className="d-block my-2 text-center">
                                    Created At:{' '}
                                    {dateTimeFormatFunction(product.created_at)}
                                </small>
                                <small className="d-block my-2 text-center">
                                    <a>
                                        <u
                                            onClick={(e) => {
                                                e.preventDefault()
                                                setShowMore(!showMore)
                                            }}
                                            className="fontweight-bold"
                                        >
                                            {!showMore
                                                ? `See More`
                                                : `Hide Details`}
                                        </u>
                                    </a>
                                </small>
                            </div>

                            <div className={showMore ? '' : 'd-none'}>
                                <div className="formFields">
                                    <label>Category</label>
                                    {/* <CustomSelect
                                        value={formik.values.category}
                                        onChange={(e) => {
                                            setInputFocus(true)
                                            formik.setFieldValue(
                                                `category`,
                                                e.target.value
                                            )
                                        }}
                                        options={category_options}
                                        className="secondaryselectField"
                                    /> */}
                                    <div
                                        className={`customSelect nonNative secondaryselectField`}
                                    >
                                        <FormControl fullWidth>
                                            <Select
                                                id="category"
                                                labelId="category-label"
                                                className="secondaryselectField"
                                                value={
                                                    formik.values.category || ''
                                                }
                                                onChange={(e) => {
                                                    setInputFocus(true)
                                                    formik.setFieldValue(
                                                        'category',
                                                        e.target.value
                                                    )
                                                }}
                                                renderValue={(selected) => {
                                                    if (!selected) {
                                                        return 'Select a Category'
                                                    }
                                                    const selectedOption =
                                                        category_options?.find(
                                                            (opt) =>
                                                                opt.value ==
                                                                selected
                                                        )
                                                    return selectedOption
                                                        ? selectedOption.show
                                                        : 'Select a Category'
                                                }}
                                                name="category"
                                            >
                                                {category_options?.map(
                                                    (opt) => (
                                                        <MenuItem
                                                            key={opt.value}
                                                            value={opt.value}
                                                        >
                                                            {opt.show}
                                                        </MenuItem>
                                                    )
                                                )}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                                <div
                                    className={`customSelect nonNative secondaryselectField subCategoryField`}
                                >
                                    <label>Sub Category :</label>
                                    <FormControl fullWidth>
                                        <InputLabel
                                            id={`sub_category`}
                                        ></InputLabel>
                                        <FormControl fullWidth>
                                            <Select
                                                id="sub_category"
                                                value={
                                                    formik.values
                                                        .sub_category || ''
                                                }
                                                onChange={(e) =>
                                                    formik.setFieldValue(
                                                        'sub_category',
                                                        e.target.value
                                                    )
                                                }
                                                renderValue={(selected) => {
                                                    console.log(
                                                        selected,
                                                        'selected'
                                                    )
                                                    if (selected == 0) {
                                                        return 'Select a Sub Category'
                                                    }
                                                    const selectedOption =
                                                        sub_category_options[
                                                            formik.values
                                                                .category
                                                        ]?.find(
                                                            (opt) =>
                                                                opt.val ==
                                                                selected
                                                        )
                                                    return selectedOption
                                                        ? selectedOption.show
                                                        : ''
                                                }}
                                                name="sub_category"
                                                inputProps={{
                                                    'aria-label':
                                                        'Without label',
                                                }}
                                            >
                                                {sub_category_options[
                                                    formik.values.category
                                                ]?.map((opt, index) => (
                                                    <MenuItem
                                                        key={index}
                                                        value={opt.val}
                                                    >
                                                        {opt.show}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </FormControl>
                                </div>
                                {/* <div className="formFields">
                                    <label>Sub Category</label>
                                    <CustomSelect
                                        value={
                                            formik.values.category[
                                                formik.values.sub_category
                                            ]
                                        }
                                        onChange={(e) => {
                                            setInputFocus(true)
                                            formik.setFieldValue(
                                                `sub_category`,
                                                e.target?.value
                                            )
                                        }}
                                        options={
                                            sub_category_options[
                                                formik.values.category
                                            ] || []
                                        }
                                        className="secondaryselectField"
                                    />
                                </div> */}
                                <div className="formFields">
                                    <label>Location in facility :</label>
                                    <CustomInput
                                        type="text"
                                        name={`bin_location`}
                                        onFocus={() => setInputFocus(true)}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.bin_location}
                                        placeholder="Enter Location in facility"
                                    />
                                </div>
                                <div className="formFields">
                                    <label>Truck Code :</label>
                                    <CustomInput
                                        type="text"
                                        name={`truck_code`}
                                        onFocus={() => setInputFocus(true)}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.truck_code}
                                        placeholder="Enter Truck Name"
                                    />
                                </div>
                                <div className="formFields">
                                    <label>Processor :</label>
                                    <CustomInput
                                        type="text"
                                        disabled={true}
                                        value={
                                            product.processor_name ||
                                            `${
                                                product?.as_employees_emp_firstname ||
                                                ''
                                            } ${
                                                product.as_employees_emp_lastname ||
                                                ''
                                            }`
                                        }
                                        placeholder="Processed By"
                                    />
                                </div>
                                <div className="formFields">
                                    <label>Warehouse :</label>
                                    <CustomInput
                                        type="text"
                                        name={`warehouse_name`}
                                        onFocus={() => setInputFocus(true)}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.warehouse_name}
                                        placeholder="Enter Warehouse"
                                    />
                                </div>
                                {/* <div
                                className="asdasd"
                                style={{
                                    border: '1px solid #000',
                                    padding: '10px',
                                    marginBottom: '15px',
                                    borderRadius: '10px',
                                }}
                            >
                                <div className="formFields">
                                    <label>Disclaimer :</label>
                                    <CustomSelect className="secondaryselectField" />
                                </div>
                            </div> */}
                                <div className="btnGridSwap">
                                    <div className="formFields">
                                        <label>Condition :</label>
                                        {/* <CustomSelect
                                            value={
                                                formik.values.conditionTypeId
                                            }
                                            onChange={(e) => {
                                                setInputFocus(true)
                                                formik.setFieldValue(
                                                    `conditionTypeId`,
                                                    e.target.value
                                                )
                                            }}
                                            options={conditionTypes}
                                            className="secondaryselectField"
                                        /> */}
                                        <FormControl fullWidth>
                                            <Select
                                                id="condition"
                                                labelId="condition-label"
                                                className="secondaryselectField"
                                                value={
                                                    formik.values
                                                        .conditionTypeId || ''
                                                }
                                                onChange={(e) => {
                                                    setInputFocus(true)
                                                    formik.setFieldValue(
                                                        'conditionTypeId',
                                                        e.target.value
                                                    )
                                                }}
                                                renderValue={(selected) => {
                                                    if (!selected) {
                                                        return 'Select a Condition'
                                                    }
                                                    const selectedOption =
                                                        conditionTypes?.find(
                                                            (opt) =>
                                                                opt.value ===
                                                                Number(selected)
                                                        )
                                                    return selectedOption
                                                        ? selectedOption.show
                                                        : 'Select a Condition'
                                                }}
                                                name="condition"
                                            >
                                                {conditionTypes?.map((opt) => (
                                                    <MenuItem
                                                        key={opt.value}
                                                        value={opt.value}
                                                    >
                                                        {opt.show}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="formFields">
                                        <label>Size/Dimension :</label>
                                        <CustomInput
                                            type="text"
                                            name={`size`}
                                            onChange={formik.handleChange}
                                            onFocus={() => setInputFocus(true)}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.size}
                                            placeholder={`Enter Size`}
                                            className="secondaryselectField"
                                        />
                                    </div>
                                </div>
                                <div className="btnGridSwap">
                                    <div className="formFields">
                                        <label>SKU :</label>
                                        <CustomInput
                                            type="text"
                                            name={`mpn`}
                                            onChange={formik.handleChange}
                                            onFocus={() => setInputFocus(true)}
                                            onBlur={formik.handleBlur}
                                            placeholder={`Enter SKU`}
                                            value={formik.values.mpn}
                                        />
                                    </div>
                                    <div className="formFields">
                                        <label>LPN :</label>
                                        <CustomInput
                                            type="text"
                                            name={`scan_lpn_number`}
                                            onChange={formik.handleChange}
                                            onFocus={() => setInputFocus(true)}
                                            onBlur={formik.handleBlur}
                                            placeholder={`Enter LPN Number`}
                                            value={
                                                formik.values.scan_lpn_number
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="btnGridSwap">
                                    <div className="formFields">
                                        <label>ASIN :</label>
                                        <CustomInput
                                            type="text"
                                            name={`asin`}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            placeholder={`Enter ASIN Number`}
                                            value={formik.values.asin}
                                        />
                                    </div>
                                    <div className="formFields">
                                        <label>UPC :</label>
                                        <CustomInput
                                            type="text"
                                            name={`upc_id`}
                                            onChange={formik.handleChange}
                                            onFocus={() => setInputFocus(true)}
                                            onBlur={formik.handleBlur}
                                            placeholder={`Enter UPC Code`}
                                            value={formik.values.upc_id}
                                        />
                                    </div>
                                </div>
                                <div className="btnGridSwap">
                                    <div className="formFields">
                                        <label>Brand :</label>
                                        <CustomInput
                                            type="text"
                                            name={`brand`}
                                            onChange={formik.handleChange}
                                            onFocus={() => setInputFocus(true)}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.brand}
                                            placeholder="Enter Brand"
                                        />
                                    </div>
                                    <div className="formFields">
                                        <label>Manufacturer :</label>
                                        <CustomInput
                                            type="text"
                                            disabled={true}
                                            name={`brand`}
                                            // name={`manufacturer`}
                                            onChange={formik.handleChange}
                                            onFocus={() => setInputFocus(true)}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.brand}
                                            placeholder="Enter Manufacturer"
                                        />
                                    </div>
                                </div>
                                <div className="formFields mb-2">
                                    <label>Enable Offer :</label>
                                    <Checkbox
                                        checked={formik.values.auction}
                                        onClick={(event) => {
                                            setInputFocus(true)
                                            formik.setFieldValue(
                                                'auction',
                                                event.target.checked
                                            )
                                        }}
                                        value={formik.values.auction}
                                    ></Checkbox>
                                </div>
                                <div className="formFields">
                                    <label>
                                        Quantity: (not for duplicate listings) :
                                    </label>
                                    {/* <CustomSelect
                                        onChange={(e) => {
                                            setInputFocus(true)
                                            formik.setFieldValue(
                                                `qty`,
                                                e.target.value
                                            )
                                        }}
                                        options={qtyOptions}
                                        value={formik.values.qty}
                                        className="secondaryselectField"
                                    /> */}
                                    <div
                                        className={`customSelect nonNative secondaryselectField`}
                                    >
                                        <FormControl fullWidth>
                                            <Select
                                                id="qty"
                                                labelId="qty-label"
                                                value={formik.values.qty || 1}
                                                onChange={(e) => {
                                                    setInputFocus(true)
                                                    formik.setFieldValue(
                                                        'qty',
                                                        e.target.value
                                                    )
                                                }}
                                                renderValue={(selected) => {
                                                    if (!selected) {
                                                        return 'Select Qty'
                                                    }
                                                    const selectedOption =
                                                        qtyOptions?.find(
                                                            (opt) =>
                                                                opt.value ===
                                                                Number(selected)
                                                        )
                                                    return selectedOption
                                                        ? selectedOption.show
                                                        : 'Select Qty'
                                                }}
                                                name="condition"
                                            >
                                                {qtyOptions?.map((opt) => (
                                                    <MenuItem
                                                        key={opt.value}
                                                        value={opt.value}
                                                    >
                                                        {opt.show}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="formFields">
                                    <label>Image Link :</label>
                                    <CustomInput
                                        type="text"
                                        name={`avatar`}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        onFocus={() => setInputFocus(true)}
                                        value={formik.values.avatar}
                                        placeholder={`Enter Image URL`}
                                        endAdornment={
                                            <span
                                                className="material-icons-outlined"
                                                style={{ cursor: 'pointer' }}
                                                onClick={(e) => {
                                                    copyExternalURL(e, `avatar`)
                                                }}
                                            >
                                                link
                                            </span>
                                        }
                                    />
                                </div>
                                <div className="formFields">
                                    {/* <CustomTagsInput */}
                                    <label>Keyword Tags :</label>
                                    <TagsInput
                                        onChange={handleTagsChange}
                                        onFocus={() => setInputFocus(true)}
                                        value={formik.values?.keywords || []}
                                        placeholder={`Enter Item Tags`}
                                    />
                                </div>
                                <div className="actionBtnGrops mt-4 mb-3">
                                    <div className="btnGridSwap">
                                        <Button
                                            disabled={true}
                                            className="primaryButton"
                                        >
                                            Print Label
                                        </Button>
                                        <Button
                                            disabled={true}
                                            className="primaryButton"
                                        >
                                            Print Bin Location
                                        </Button>
                                    </div>
                                </div>
                                <div className="formFields">
                                    <label>Duplicate Listing:</label>
                                    <CustomSelect
                                        onChange={(e) => {
                                            setInputFocus(true)
                                            formik.setFieldValue(
                                                `duplicateLotCount`,
                                                e.target.value
                                            )
                                        }}
                                        value={formik.values.duplicateLotCount}
                                        options={qtyOptions}
                                        className="secondaryselectField"
                                    />
                                </div>
                                <div className="actionBtnGrops text-center mt-1">
                                    <Button
                                        onClick={(e) => duplicateLot(e)}
                                        // type="submit"
                                        disabled={true}
                                        className="primaryButton"
                                    >
                                        Create
                                    </Button>
                                </div>
                            </div>
                        </DialogContent>
                    </>
                )}
                {/* <DialogActions className="justify-content-center mt-1"></DialogActions> */}
            </Dialog>
            <CustomDialog
                title={
                    <div>
                        Unsaved Changes
                        <span
                            className="material-icons"
                            onClick={(e) => {
                                setSubmitPopup(false)
                            }}
                        >
                            clear
                        </span>
                    </div>
                }
                className={`lotNotes unsavedDialog`}
                open={submitPopup}
            >
                <div className="d-flex justify-center text-center justify-content-center">
                    <p>
                        Are you sure you want to exit? <br />
                        <strong>Your progress will not be saved</strong>
                    </p>
                </div>
                <div className="d-flex justify-center justify-content-center">
                    {/* <Button
                        onClick={(e) => {
                            setSubmitPopup(false)
                        }}
                        className="secondaryButton mr-2"
                    >
                        CANCEL
                    </Button> */}
                    <PrimaryButton
                        id="inventory_update"
                        label="CONFIRM"
                        onClick={(e) => {
                            props.handleClose()
                            setSubmitPopup(false)
                        }}
                    />
                </div>
            </CustomDialog>
        </>
    )
}

export default EditModal
